import { IDateCalculateBehavior } from "./IDateCalculateBehavior";

export interface IDateCalculateBehaviorSpecifiable {
  dateCalculateBehavior: IDateCalculateBehavior;
}

export function instanceOfIDateCalculateBehaviorSpecifiable(instance: any): instance is IDateCalculateBehaviorSpecifiable {
  return instance
    && (instance.dateCalculateBehavior !== undefined);
}
